import React from 'react';
import { Box, Typography, Container, Button, useTheme } from '@mui/material';

// import RegisterPopup from '../auth/RegisterPopup';
// import LoginPopup from '../auth/LoginPopup';
// import ForgotPasswordPopup from '../auth/ForgotPasswordPopup';

import PopupModal from '../auth/PopupModal';

const CTA = () => {
    const theme = useTheme();
    const [activePopup, setActivePopup] = React.useState(null);
    const handlePopupClose = () => {
        setActivePopup(null);
    };

    const handlePopupOpen = (popupName) => {
        setActivePopup(popupName);
    };

    return (
        <Box
            sx={{
                backgroundColor: "primary.dark",
                color: 'white',
                padding: theme.spacing(8, 2),
                textAlign: 'center',
                borderRadius: 4,
                boxShadow: 3,
            }}
        >
            <Container maxWidth="lg">

                {/* Heading */}
                <Typography
                    variant="h3"
                    sx={{
                        fontWeight: 700,
                        fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' },
                        marginBottom: theme.spacing(2),
                        color: 'white',
                    }}
                >
                    Ready to Clear Your Concepts with Glassyfied?
                </Typography>

                {/* Subheading */}
                <Typography
                    variant="h6"
                    sx={{
                        fontWeight: 400,
                        fontSize: { xs: '1rem', sm: '1.2rem' },
                        marginBottom: theme.spacing(4),
                        color: 'white',
                        maxWidth: '600px',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                    }}
                >
                    Get started with Glassyfied and unlock the power of AI for your learning journey. Ask questions, create notes, and generate content with ease.
                </Typography>

                {/* Main CTA Button */}
                <Button
                    variant="contained"
                    // color="secondary"
                    size="large"
                    sx={{
                        textTransform: 'none',
                        fontWeight: 600,
                        borderRadius: '8px',
                        padding: theme.spacing(1.5, 4),
                        marginBottom: 2,
                        // fontSize: { xs: '1rem', sm: '1rem' },
                        marginRight: 2,
                        border: 2,
                        borderColor: "primary.light",
                        color: "primary.dark",
                        backgroundColor: "primary.light",
                        '&:hover': {
                            backgroundColor: "primary.main",
                            color: "primary.contrastText",
                            borderColor: "primary.main",
                        },
                    }}
                    onClick={() => handlePopupOpen("login")}
                >
                    Get Started for Free
                </Button>
            </Container>
            <PopupModal
                activePopup={activePopup}
                handlePopupClose={handlePopupClose}
                handlePopupOpen={handlePopupOpen}
            />
        </Box>
    );
};

export default CTA;
